(function () {
  const VIDEO_SRC = "https://assets.website-files.com/63e3c47f1404654dda7a943a/63e50da0b9836c165247df8a__hand_wipes_scene01-transcode.mp4";
  const CONTAINER_ID = "scrolly-video";

  let inited = false;
  let retries = 0;

  function isReady() {
    return (
      typeof window !== "undefined" &&
      window.gsap &&
      window.ScrollTrigger &&
      window.ScrollyVideo &&
      document.getElementById(CONTAINER_ID)
    );
  }

  function refreshScrollTriggerSafely() {
    try {
      if (window.ScrollTrigger) {
        window.ScrollTrigger.refresh(true);
      }
    } catch (_) {}
  }

  async function waitFonts() {
    try {
      if (document.fonts && document.fonts.ready) {
        await document.fonts.ready;
      }
    } catch (_) {}
  }

  function init() {
    if (inited || !isReady()) return false;
    inited = true;

    try {
      gsap.registerPlugin(ScrollTrigger);
    } catch (_) {}

    const instance = new ScrollyVideo({
      scrollyVideoContainer: CONTAINER_ID,
      src: VIDEO_SRC,
    });

    const wrap = document.getElementById(CONTAINER_ID);
    const video = wrap ? wrap.querySelector("video") : null;

    if (video) {
      video.muted = true;
      video.playsInline = true;
      video.setAttribute("muted", "");
      video.setAttribute("playsinline", "");
      video.setAttribute("preload", "auto");

      const onMeta = () => {
        refreshScrollTriggerSafely();
        video.removeEventListener("loadedmetadata", onMeta);
      };
      video.addEventListener("loadedmetadata", onMeta);
    }

    window.addEventListener("load", () => {
      refreshScrollTriggerSafely();
      setTimeout(refreshScrollTriggerSafely, 100);
    });

    waitFonts().then(() => {
      refreshScrollTriggerSafely();
      requestAnimationFrame(refreshScrollTriggerSafely);
    });

    let resizeTO;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTO);
      resizeTO = setTimeout(refreshScrollTriggerSafely, 150);
    });

    const mql = window.matchMedia("(prefers-reduced-motion: reduce)");
    if (mql.matches) {
    }

    return true;
  }

  function tryInit() {
    if (init()) return;
    if (retries < 20) {
      retries += 1;
      setTimeout(tryInit, 100);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", tryInit, { once: true });
  } else {
    tryInit();
  }
})();